import React from "react";
import { hot } from 'react-hot-loader';

const copyObject = (data) => {
  return Object.assign({}, JSON.parse(JSON.stringify(data)));
}

const FontSizeSelect = ({ setting, setSetting }) => {
  const font = setting.font;

  return (
    <div className="select">
      <form>
        <select name="font" value={font} onChange={(e) => {
          const newSetting = copyObject(setting);
          newSetting.font = e.target.value;
          setSetting(newSetting);
        }}>
          <option key="small" value="small">小さめ</option>
          <option key="standard" value="standard">標準</option>
          <option key="large" value="large">大きめ</option>
        </select>
      </form>
    </div>
  );
}

export default hot(module)(FontSizeSelect);
